import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { MinusIcon, PlusIcon } from '../../../../assets/svg';
import { COLORS, device } from '../../../../constants';
import { Title, Text } from '../../../../components';
import { FaqSubItem } from '../../../../types/globalTypes';

interface AccordionItemProps {
  item: FaqSubItem;
}

export const AccordionSubitem: React.FC<AccordionItemProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionWrapper>
      <AccordionHeader onClick={toggleAccordion}>
        <Plus>{isOpen ? <MinusIcon /> : <PlusIcon />}</Plus>
        <Title
          title={item.Title}
          minHeight={0}
          size={18}
          weight={600}
          lineHeight={30}
        />
      </AccordionHeader>
      {typeof item.Description === 'string' ? (
        <AccordionContent $isOpen={isOpen}>
          <Text text={item.Description} size={18} />
        </AccordionContent>
      ) : (
        item.isList && (
          <ListContainer $isOpen={isOpen}>
            {item.Description.map((description, index) => (
              <ListItem key={index}>
                <Text text={description} size={18} />
              </ListItem>
            ))}
          </ListContainer>
        )
      )}
    </AccordionWrapper>
  );
};
const AccordionWrapper = styled.div`
  padding: 40px 40px 40px 20px;
  border-bottom: 1px solid ${COLORS.STEP_ACTIVE_COLOR};
  @media screen and ${device.md} {
    padding: 15px 15px 15px 10px;
  }
  @media screen and ${device.sm} {
    padding: 10px;
  }
`;
const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  @media screen and ${device.md} {
    > span {
      font-size: 13px;
      font-weight: 600;
      line-height: 17px;
    }
  }
  @media screen and ${device.sm} {
    > span {
      font-size: 10px;
      line-height: 15px;
      font-weight: 500;
    }
    padding: 0;
  }
`;

const Plus = styled.span`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and ${device.sm} {
    width: 15px;
    height: 15px;
  }
`;

const AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? 'none' : '0')};
  overflow: hidden;
  transition: all 0.2s ease;
  border-top: none;
  padding-left: 40px;
  margin-top: ${({ $isOpen }) => ($isOpen ? '40px' : '0')};
  @media screen and ${device.md} {
    > h4 {
      font-size: 16px;
      line-height: 21px;
    }
  }
  @media screen and ${device.md} {
    padding-left: 20px;
    margin-top: ${({ $isOpen }) => ($isOpen ? '10px' : '0')};
  }
  @media screen and ${device.sm} {
    padding-left: 10px;
    > h4 {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

const ListContainer = styled.ul<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? 'none' : '0')};
  margin-top: ${({ $isOpen }) => ($isOpen ? '40px' : '0')};
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  transition: all 0.2s ease;
  border-top: none;
  list-style-type: disc;
  color: ${COLORS.STEP_RED_BORDER};
  padding-left: 40px;
  @media screen and ${device.md} {
    padding-left: 20px;
    margin-top: ${({ $isOpen }) => ($isOpen ? '10px' : '0')};
  }
  @media screen and ${device.sm} {
    padding-left: 10px;
    gap: 0;
  }
`;

const ListItem = styled.li`
  @media screen and ${device.md} {
    > h4 {
      font-size: 16px;
      line-height: 21px;
    }
  }
  @media screen and ${device.md} {
  }
  @media screen and ${device.sm} {
    > h4 {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
